/* ==========================================================================
   AULBERY — MOTION ENGINE  (as-motion.js)
   Load deferred from theme.liquid.
   Drives: .reveal / .reveal-group (scroll rise, replays on every re-entry)
           [data-morph] (looping typeface melt)
           [data-hover-morph] (hover typeface melt)
   Safe with the Shopify theme editor (re-inits on section load).
   ========================================================================== */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observed = new WeakSet();
  var morphed = new WeakSet();
  var io = null;

  /* ---------------- Reveal (signature 02 — Rise) ---------------- */

  function getObserver() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
        } else if (e.boundingClientRect.top > 0) {
          /* Reset only after the element has fully left BELOW the viewport,
             so nothing fades out mid-read while scrolling up. Replays on
             every scroll back down. */
          e.target.classList.remove('in');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    return io;
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reveal, .reveal-group');
    els.forEach(function (el) {
      if (observed.has(el)) return;
      if (reduced) { el.classList.add('in'); return; }
      observed.add(el);
      getObserver().observe(el);
    });
  }

  /* ---------------- Type morph (signature 06) ----------------
     Markup contract (matches the approved demo):
       <div data-morph data-interval="2400">
         <div class="goo">
           <div class="layer ... active">Text</div>
           <div class="layer ...">Text</div>
         </div>
       </div>
  ------------------------------------------------------------- */

  function initMorph(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-morph]').forEach(function (strip) {
      if (morphed.has(strip)) return;
      morphed.add(strip);
      var layers = Array.prototype.slice.call(strip.querySelectorAll('.layer'));
      if (layers.length < 2) return;
      if (reduced) return; /* first layer stays static */
      var interval = parseInt(strip.getAttribute('data-interval') || '2400', 10);
      var i = 0;
      setInterval(function () {
        layers[i].classList.remove('active');
        i = (i + 1) % layers.length;
        layers[i].classList.add('active');
      }, interval);
    });

    scope.querySelectorAll('[data-hover-morph]').forEach(function (btn) {
      if (morphed.has(btn)) return;
      morphed.add(btn);
      var layers = Array.prototype.slice.call(btn.querySelectorAll('.layer'));
      if (layers.length < 2) return;
      var set = function (idx) {
        layers.forEach(function (l, n) { l.classList.toggle('active', n === idx); });
      };
      if (reduced) { set(0); return; }
      btn.addEventListener('mouseenter', function () { set(1); });
      btn.addEventListener('mouseleave', function () { set(0); });
      btn.addEventListener('focus', function () { set(1); });
      btn.addEventListener('blur', function () { set(0); });
    });
  }

  /* ---------------- Boot ---------------- */

  function init(root) {
    initReveal(root);
    initMorph(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme editor: sections are re-rendered on the fly — re-init inside them */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
